import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader, RequestContentType } from 'utils/Helpers'

const OrgAPI = Marty.createStateSource({
  id: 'OrgAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  createOrg(settings) {
    return this.post({
      url: `/organizations?clientId=${ ResourcesConstants.CLIENT_ID }`,
      contentType: RequestContentType.JSON,
      body: JSON.stringify(settings)
    })
  },

  fetchOrgById(orgId) {
    return this.get({
      url: `/organizations/${ orgId }`,
      headers: getAuthorizationHeader()
    })
  },

  shareEmailSnippet(email, orgId) {
    return this.post({
      url: `/snippets/send?email=${ email }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify([{ email }])
    })
  },

  updateOrg(orgId, update) {
    return this.patch({
      url: `/organizations/${ orgId }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(update)
    })
  },
})

export default OrgAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/OrgAPI.js